import { styled } from '@mui/material'
import Tooltip, { type TooltipProps, tooltipClasses } from '@mui/material/Tooltip'
import { FC, ReactElement, ReactNode } from 'react'

type Props = {
  background?: string
  color?: string
  open?: boolean
  title: ReactNode
  children: ReactElement<any, any>
  interactive?: boolean
}

const CustomTooltip: FC<Props> = ({ background, color, open, title, children, interactive = false }) => {
  if (!title) {
    return children
  }

  return (
    <StyledTooltip
      arrow
      color={color}
      disableInteractive={!interactive}
      open={open}
      sx={{
        ...(background && {
          '& .MuiTooltip-arrow': {
            color: background,
          },
          '& .MuiTooltip-tooltip': {
            backgroundColor: background,
          },
        }),
      }}
      title={title}
    >
      {children}
    </StyledTooltip>
  )
}

const StyledTooltip = styled(({ className, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }} /> // we need to manually pass the className to the popper for the styling to work
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    color: '#ffffff',
    maxWidth: 320,
    fontSize: 14,
    textAlign: 'center',
  },
}))

export default CustomTooltip
